import { render, staticRenderFns } from "./modelBrandPage.vue?vue&type=template&id=88bc2c5c&scoped=true&"
import script from "./modelBrandPage.vue?vue&type=script&lang=js&"
export * from "./modelBrandPage.vue?vue&type=script&lang=js&"
import style0 from "./modelBrandPage.vue?vue&type=style&index=0&id=88bc2c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bc2c5c",
  null
  
)

export default component.exports